module.exports = __webpack_public_path__ + "img/pricing-bg.705a90e0.svg";